import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { eventsData } from "./eventsData";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ScrollAdd from "../components/ScrollAdd";
import "./EventDetail.css";

const EventDetail = () => {
  const { id } = useParams();
  const [event, setEvent] = useState(null);
  const [modalImage, setModalImage] = useState(null);

  useEffect(() => {
    const foundEvent = eventsData.find((e) => e.id === id);
    setEvent(foundEvent);
    window.scrollTo(0, 0);
  }, [id]);

  const openModal = (imgUrl) => {
    setModalImage(imgUrl);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setModalImage(null);
    document.body.style.overflow = "auto";
  };

  if (!event) {
    return (
      <>
        <Navbar />
        <div className="event-not-found">
          <h2>Event Not Found</h2>
          <Link to="/upcoming-event" className="back-btn">Back to Events</Link>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      {/* <ScrollAdd /> */}
      {/* <Navbar /> */}
      <div className="event-detail-page">
        {/* Hero Section */}
        <div className="detail-header" style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url(${event.image})` }}>
          <div className="header-content">
            <Link to="/upcoming-event" className="back-link">← Back to All Events</Link>
            <div className="detail-badge">{event.ageGroup}</div>
            <h1 className="detail-title">{event.title}</h1>
            <p className="detail-subtitle">{event.subtitle}</p>
          </div>
        </div>

        <div className="detail-container">
          <div className="detail-main-content">
            <div className="detail-card glassmorphism">

              {/* About Section */}
              <div className="content-section intro-section">
                <h2 className="section-title">🚀 About the Program</h2>
                <p className="about-text">{event.aboutProgram}</p>
              </div>

              {/* Training Model Section */}
              {event.trainingModel && (
                <div className="content-section training-model-section">
                  <h2 className="section-title">🎯 Our Training Model: {event.trainingModel.title}</h2>
                  <div className="training-steps">
                    {event.trainingModel.steps.map((step, i) => (
                      <div key={i} className="step-item">
                        <div className="step-number">{i + 1}</div>
                        <p>{step}</p>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Activities Section */}
              <div className="content-section activities-section">
                <h2 className="section-title">🧠 Activities & Learning Experience</h2>

                {event.activities.primary && (
                  <div className="age-group-activities">
                    <h3 className="age-title">👦 Primary School (4–8 Years)</h3>
                    <div className="activities-grid">
                      {event.activities.primary.map((act, i) => (
                        <div key={i} className="activity-item">
                          <h4 className="activity-title">{act.title}</h4>
                          <p className="activity-desc">{act.desc}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {event.activities.highschool && (
                  <div className="age-group-activities">
                    <h3 className="age-title">🧑 High School (9–15 Years)</h3>
                    <div className="activities-grid">
                      {event.activities.highschool.map((act, i) => (
                        <div key={i} className="activity-item">
                          <h4 className="activity-title">{act.title}</h4>
                          <p className="activity-desc">{act.desc}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              {/* Daily Schedule Section */}
              <div className="content-section schedule-section">
                <h2 className="section-title">🕒 Daily Schedule</h2>
                <div className="schedule-card">
                  <div className="schedule-info">
                    <i className="fas fa-calendar-alt"></i>
                    <span>{event.dailySchedule.days}</span>
                  </div>
                  <div className="schedule-list">
                    <p>Each day includes:</p>
                    <ul>
                      {event.dailySchedule.includes.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              {/* Special Highlights */}
              <div className="content-section highlights-section">
                <h2 className="section-title">🌟 Special Experience Activities</h2>
                <div className="highlights-list-grid">
                  {event.specialHighlights.map((h, i) => (
                    <div key={i} className="highlight-list-item">
                      <i className="fas fa-check-circle"></i>
                      <span>{h}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Why Choose Section */}
              <div className="content-section why-choose-section">
                <h2 className="section-title">💡 Why Choose Learnorama?</h2>
                <div className="why-grid">
                  {event.whyChoose.map((point, i) => (
                    <div key={i} className="why-item">
                      <i className="fas fa-star"></i>
                      <span>{point}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Learning Outcomes */}
              <div className="content-section outcome-section">
                <h2 className="section-title">🎯 Learning Outcome</h2>
                <p className="outcome-intro">By the end of the camp, students will gain:</p>
                <div className="outcome-grid">
                  {event.learningOutcomes.map((outcome, i) => (
                    <div key={i} className="outcome-item">
                      <i className="fas fa-graduation-cap"></i>
                      <span>{outcome}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Brochures Section */}
              {event.brochures?.length > 0 && (
                <div className="content-section brochures-section">
                  <h2 className="section-title">📄 Camp Brochures</h2>
                  <div className="brochures-grid">
                    {event.brochures.map((url, i) => (
                      <div
                        key={i}
                        className="brochure-item"
                        onClick={() => openModal(url)}
                      >
                        <img src={url} alt={`Brochure ${i + 1}`} className="brochure-img" />
                        <div className="brochure-overlay">
                          <i className="fas fa-search-plus"></i>
                          <span>Click to Enlarge</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Venue & Registration Sidebar (for desktop) / Bottom CTA (for mobile) */}
              <div className="details-footer">
                <div className="footer-info">
                  <div className="info-block">
                    <strong>📍 Venue</strong>
                    <span>{event.venue}</span>
                  </div>
                  <div className="info-block">
                    <strong>💰 Fee</strong>
                    <span>{event.fee}</span>
                  </div>
                </div>

                <div className="cta-box">
                  <Link to="/enrollment" className="register-now-btn">
                    Register Online Now
                  </Link>
                  <div className="contact-numbers">
                    <span>📞 {event.contact}</span>
                  </div>
                </div>
              </div>

              <div className="closing-line">
                <p>👉 Don’t just let your child spend summer…</p>
                <p>👉 Let them build skills for life.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Image Modal */}
        {modalImage && (
          <div className="image-modal-overlay" onClick={closeModal}>
            <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="close-modal-btn" onClick={closeModal}>×</button>
              <img src={modalImage} alt="Brochure" />
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default EventDetail;
